export default __webpack_public_path__ + "static/media/pod.1ec0ec5a.svg";